import { z } from 'zod';

export const OrganizationPrivateNetworkingEntitlement = z.object({
  id: z.string(),
  organizationId: z.string(),
  enabled: z.boolean(),
  whitelistedHosts: z.array(z.string()),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type OrganizationPrivateNetworkingEntitlement = z.infer<
  typeof OrganizationPrivateNetworkingEntitlement
>;

export const OrganizationPrivateNetworkingEntitlements = z.array(
  OrganizationPrivateNetworkingEntitlement,
);

export type OrganizationPrivateNetworkingEntitlements = z.infer<
  typeof OrganizationPrivateNetworkingEntitlements
>;

export const CreateOrganizationPrivateNetworkingEntitlementRequest = z.object({
  organizationId: z.string(),
  enabled: z.boolean(),
  whitelistedHosts: z.array(z.string()),
});

export type CreateOrganizationPrivateNetworkingEntitlementRequest = z.infer<
  typeof CreateOrganizationPrivateNetworkingEntitlementRequest
>;

export const UpdateOrganizationPrivateNetworkingEntitlementRequest = z.object({
  enabled: z.boolean().optional(),
  whitelistedHosts: z.array(z.string()).optional(),
});

export type UpdateOrganizationPrivateNetworkingEntitlementRequest = z.infer<
  typeof UpdateOrganizationPrivateNetworkingEntitlementRequest
>;
